import { dashboardMetrics, recentActivities } from "../data/dashboard";
import { Link } from "react-router-dom";

const statIcons = ["bi-currency-rupee", "bi-bag-check", "bi-truck", "bi-exclamation-triangle"];

function getActivityIcon(text: string) {
  if (text.toLowerCase().includes("order")) return "bi-bag-check-fill";
  if (text.toLowerCase().includes("stock")) return "bi-boxes";
  if (text.toLowerCase().includes("refund")) return "bi-arrow-return-left";
  if (text.toLowerCase().includes("customer")) return "bi-person-plus-fill";
  return "bi-bell-fill";
}

const quickLinks = [
  { label: "Add Product",     icon: "bi-plus-circle",   to: "/admin/products",  color: "#b8400e" },
  { label: "View Orders",     icon: "bi-bag-check",     to: "/admin/orders",    color: "#0e7490" },
  { label: "Check Inventory", icon: "bi-boxes",         to: "/admin/inventory", color: "#7c3aed" },
  { label: "Reviews",         icon: "bi-star",          to: "/admin/reviews",         color: "#d97706" },
];

const healthStats = [
  { label: "Orders Fulfilment",      pct: 92, color: "#16a34a" },
  { label: "Customer Satisfaction",  pct: 87, color: "var(--theme)" },
  { label: "Stock Availability",     pct: 74, color: "#d97706" },
];

export function DashboardPage() {
  return (
    <div className="page-enter">
      {/* Welcome banner */}
      <div className="ns-welcome-banner">
        <div className="wb-orb1" />
        <div className="wb-orb2" />
        <div>
          <div className="ns-wb-greeting">Good morning 👋</div>
          <div className="ns-wb-title">NineSistersJewels Admin</div>
          <div className="ns-wb-sub">Here's what's happening with your store today.</div>
        </div>
        <div className="ns-wb-date-chip">
          <i className="bi bi-calendar3"></i>
          {new Date().toLocaleDateString("en-IN", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
        </div>
      </div>

      {/* Stats */}
      <div className="ns-stats-grid ns-mb-24">
        {dashboardMetrics.map((m, i) => (
          <div key={m.label} className={`ns-stat-card ${i === 0 ? "stat-primary" : ""}`}>
            <div className="stat-label">{m.label}</div>
            <div className="stat-value">{m.value}</div>
            <div className="stat-change">
              <i className={`bi bi-arrow-up-right ${i === 0 ? "stat-arrow" : "stat-arrow"}`}></i>&nbsp;
              {["+12% this month", "+8 from yesterday", "4 dispatched today", "2 critical"][i]}
            </div>
            <i className={`bi ${statIcons[i]} stat-icon`}></i>
          </div>
        ))}
      </div>

      <div className="ns-dash-grid">
        {/* Recent Activity */}
        <div className="ns-card">
          <div className="ns-card-header">
            <div className="ns-card-title">
              <i className="bi bi-clock-history ns-icon-theme"></i>
              Recent Activity
            </div>
            <span className="ns-badge badge-theme">{recentActivities.length} new</span>
          </div>
          <div>
            {recentActivities.map((activity, i) => (
              <div key={i} className="ns-activity-row">
                <div className="ns-activity-icon">
                  <i className={`bi ${getActivityIcon(activity)}`} style={{ color: "var(--theme)", fontSize: 15 }}></i>
                </div>
                <div>
                  <div className="ns-activity-text">{activity}</div>
                  <div className="ns-activity-time">Just now</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column */}
        <div>
          {/* Quick Actions */}
          <div className="ns-card ns-mb-16">
            <div className="ns-card-header">
              <div className="ns-card-title">
                <i className="bi bi-lightning-charge ns-icon-theme"></i>
                Quick Actions
              </div>
            </div>
            <div className="ns-quick-grid">
              {quickLinks.map((q) => (
                <Link key={q.label} to={q.to} className="ns-quick-link">
                  <div className="ns-quick-icon" style={{ background: q.color + "18" }}>
                    <i className={`bi ${q.icon}`} style={{ color: q.color, fontSize: 18 }}></i>
                  </div>
                  <span className="ns-quick-label">{q.label}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* Store Health */}
          <div className="ns-card">
            <div className="ns-card-header">
              <div className="ns-card-title">
                <i className="bi bi-heart-pulse ns-icon-theme"></i>
                Store Health
              </div>
            </div>
            <div className="ns-health-body">
              {healthStats.map(s => (
                <div key={s.label}>
                  <div className="ns-health-row-head">
                    <span className="ns-health-label">{s.label}</span>
                    <span className="ns-health-pct" style={{ color: s.color }}>{s.pct}%</span>
                  </div>
                  <div className="ns-health-track">
                    <div className="ns-health-bar" style={{ width: `${s.pct}%`, background: s.color }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
